// @flow
import React from "react"
import { isNil } from "ramda"
import { compose, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import urls from "data/router/urls"
import { selectItems } from "data/basket/selectors"
import { ShoppingBasketLinkWrap } from "./styled"

const ShoppingBasketLink = ({ items }) => (
  <ShoppingBasketLinkWrap to={urls.shoppingBasket}>
    cart&nbsp;{items.length === 0 ? "" : `(${items.length})`}
  </ShoppingBasketLinkWrap>
)

const mapStateToProps = state => ({
  items: selectItems(state),
})

const enhancer: HOC<*, {||}> = compose(
  withConnect(mapStateToProps),
)

export default enhancer(ShoppingBasketLink)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/ShoppingBasketLink/index.js